module.exports = __webpack_public_path__ + "img/login.e53dad35.png";